import NavEditApi from '@/api/nav.edit.api.js'

const state = {
	showNavEdit: false, //导航编辑弹窗显示隐藏
	navDomOptions: {}, // 当前编辑导航的属性参数
	curProjNavMenu: [], // 当前导航数据
	showSelectPageNav: false, //控制导航弹窗的显示隐藏
	curNavMenuUnique: '', // 当前要添加的导航的order唯一标记
	curType: 'add'
}

const getters = {
	getCurProjNavMenuCount(state) {
		return state.curProjNavMenu.length
	},
	getAllNavMenu(state) {
		let allNavMenu = []
		state.curProjNavMenu.forEach(item => {
			allNavMenu = item.children ? [...allNavMenu, item, ...item.children] : [...allNavMenu, item]
		})
		return allNavMenu
	}
}

const mutations = {
	setNavEditState(state, data) {
		for (let keys in data) {
			if (data.hasOwnProperty(keys)) {
				state[keys] = data[keys]
			}
		}
	}
}
const actions = {
	/**
	 * 获取导航
	 * @param {Object} params
	 * @param {String} params.projId
	 */
	getProjMenu(context, params) {
		return NavEditApi.getProjMenu(params)
	},
	/**
	 * 导航保存
	 * @param {Object} data
	 * @param {Array} data.menuList
	 * @param {Object} data.param
	 */
	saveEditMenu(context, data) {
		return NavEditApi.saveEditMenu(data)
	},

	/**
	 * 修改页面名称
	 * @param {Object} data 数据
	 */
	editPageName(context, data) {
		return NavEditApi.editPageName(data)
	},
	/**
	 * 获取页面管理展示的数据
	 * @param {*} params
	 */
	getProjPageNav(context, params) {
		return NavEditApi.getProjPageNav(params)
	}
}

export default {
	state,
	getters,
	mutations,
	actions,
	namespaced: true
}
